<!--  -->
<template>
  <div>
    <div id="rightdiv">
      <p v-html="xwxq.content"></p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: this.$route.params.id,
      xwxq: ""
    };
  },

  components: {},
  mounted: function() {
    this.getxwxq();
  },
  methods: {
    getxwxq() {
      this.$http
        .get(
          "SSM-master/marcoNews/getById?newsId=" +
            this.id
        )
        .then(response => {
          this.xwxq = response.data;
          response => {
            console.log("出错了");
          };
        });
    }
  }
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/profile/xwxq.vue